import React, { memo, useMemo } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import AmountField, { AmountFieldSkeleton } from 'forms/fields/AmountField';
import { Short2RowsTeaser } from 'components/SpecialistTeaser';
import TicketsField, { TicketsFieldSkeleton } from 'forms/fields/TicketsField';
import { IconButton } from 'components/Button';
import { useMobile } from 'utils/media';
import { Skeleton } from '@mui/material';
import { Short2RowsTeaserSkeleton } from 'components/SpecialistTeaser/Short2RowsTeaser';

const { el } = bem('order-form', 'form');
const Tickets = (props) => {
    const {
        selectedEvents,
        setSelectedEvents,
        workingOffline,
        onSaveClick,
        specialist,
        amount,
        setAmount,
        setTicketType,
        ticketOptions,
        events
    } = props;

    const amountFieldProps = {
        specialist,
        amount,
        setAmount,
        setTicketType,
        ticketOptions
    }

    const ticketsFieldProps = {
        events,
        selectedEvents,
        setSelectedEvents,
        workingOffline
    }

    const isEnabled = useMemo(() => selectedEvents.every(event => !!event), [ selectedEvents ]);

    return (
        <div className={ el('tickets-block') }>
            <div className={ el('tickets-block-top') }>
                <div className={ el('amount') }>
                    <div className={ el('amount-label') }>
                        <Text>Выберите количество консультаций</Text>
                    </div>
                    <AmountField { ...amountFieldProps }/>
                </div>
                <div className={ el('separator') }/>
                <div className={ el('specialist') }>
                    <Short2RowsTeaser specialist={ specialist }/>
                </div>
                <div className={ el('tickets') }>
                    <TicketsField {...ticketsFieldProps }/>
                </div>
            </div>
            <div className={ el('tickets-buttons') }>
                <IconButton type="button" className={ el('save-button') } name={ 'arrow-right' } mod={ 'gold' }
                            disabled={ !isEnabled } onClick={ onSaveClick }>
                    <Text>Сохранить</Text>
                </IconButton>
            </div>
        </div>
    );
};

export const TicketsSkeleton = () => {
    const { isMobile } = useMobile();
    return (
        <div className={ el('tickets-block') }>
            <div className={ el('amount') }>
                <div className={ el('amount-label') }>
                    <Text><Skeleton width={ 200 }/></Text>
                </div>
                <AmountFieldSkeleton/>
            </div>
            <div className={ el('separator') }/>
            <div className={ el('specialist') }>
                <Short2RowsTeaserSkeleton/>
            </div>
            <div className={ el('tickets') }>
                <TicketsFieldSkeleton/>
            </div>
            <div className={ el('tickets-buttons') }>
                <Skeleton variant="rectangular" style={ { borderRadius: '10px' } } width={ isMobile ? '100%' : 300 }
                          height={ 52 }/>
            </div>
        </div>
    );
};

export default memo(Tickets);
